import React, { useMemo, useState } from "react";
import { Grid, Box } from "@mui/material";

import { useGetProformaInvoiceSearchDTO } from "../../../Reports/ReportList/Hook";
import { useGetAllKlischeThikness } from "../../../Production/OrderArchive/Hook";

import YearsDrop from "../components/YearsDrop";
import PersianDatePicker from "../components/PersianDatePicker";
import DySelect from "../../../../General/Components/DySelect/DySelect";

function Filter({
  // customer & designer (kept for future use)
  setFieldValue,
  setDesignerFiled,
  customerFieldValue,
  designerFiled,

  // date
  chartFilter,
  year,
  setYear,
  month,
  setMonth,
  day,
  setDay,

  // klische
  KlischeType,
  KilscheThicknes,
  setKilscheThicknes,
}) {
  const { data } = useGetProformaInvoiceSearchDTO();

  const { data: thickness } = useGetAllKlischeThikness(
    KlischeType?.KlischeType,
  );

  const thicknessOptions = useMemo(
    () =>
      thickness?.map((item) => ({
        value: item.id,
        key: item.thickness,
      })),
    [thickness],
  );

  return (
    <Grid container sx={{ width: "100%" }} spacing={1}>
      {/* Date Filters */}
      <Grid item xs={12} md={6}>
        {chartFilter.enum === 0 && (
          <PersianDatePicker
            year={year}
            setYear={setYear}
            month={month}
            setMonth={setMonth}
            day={day}
            setDay={setDay}
            withDay
          />
        )}

        {chartFilter.enum === 1 && (
          <PersianDatePicker
            year={year}
            setYear={setYear}
            month={month}
            setMonth={setMonth}
          />
        )}

        {chartFilter.enum === 2 && <YearsDrop year={year} setYear={setYear} />}
      </Grid>

      {/* Klische Thickness */}
      <Grid item xs={12} md={6}>
        <DySelect
          label="ضخامت کلیشه"
          selectValue={KilscheThicknes}
          setSelectValue={setKilscheThicknes}
          name="KilscheThicknes"
          items={thicknessOptions}
          showRemove
        />
      </Grid>
    </Grid>
  );
}

export default Filter;
